/* Text library (tilbudstekster): statuses and per-case basis. Status is about the library text; basis is about how the case uses it. */
export const TEXT_STATUS = {
  bekreftet: { label: "Bekreftet", cls: "v-ok", hint: "Bekreftet Skarpenord-tekst med kilde." },
  historisk: { label: "Historisk kildetekst", cls: "v-assumed", hint: "Ordlyd fra et tidligere Skarpenord-dokument. Kildetekst – ikke gjeldende standard. Må gjennomgås på saken." },
  demo: { label: "Demo", cls: "bg-[hsl(268_35%_48%/0.12)] text-[hsl(268_35%_36%)]", hint: "Skrevet for prototypen – ikke Skarpenord-tekst. Kan brukes i utkast, aldri i kontrollert tilbud." },
  utkast: { label: "Utkast", cls: "bg-black/[0.06] text-foreground/70", hint: "Under arbeid i biblioteket." },
};
export const TEXT_STATUS_OPTIONS = Object.entries(TEXT_STATUS).map(([k, v]) => [k, v.label]);

export const TEXT_BASIS = {
  standard: { label: "Standard", hint: "Bibliotekets standardtekst for nye tilbud – følger standarden til revisjonen fryses." },
  valgt: { label: "Valgt fra biblioteket", hint: "Valgt på saken og låst til denne versjonen av teksten." },
  overstyrt: { label: "Overstyrt på saken", hint: "Teksten fra biblioteket er endret på denne saken." },
  manuell: { label: "Skrevet på saken", hint: "Fri tekst skrevet på denne saken – ikke fra biblioteket." },
  tom: { label: "Ikke med", hint: "Seksjonen er tom og vises ikke i dokumentet." },
};

/** Short, honest description of one resolved section: «Valgt · Historisk kildetekst · v1», «Skrevet på saken», «Ikke med». */
export function basisSummary(r) {
  if (!r) return "";
  const b = TEXT_BASIS[r.basis]?.label || r.basis;
  const t = r.template;
  if (!t || r.basis === "manuell" || r.basis === "tom") return b;
  return `${b} · ${TEXT_STATUS[t.status]?.label || t.status} · v${t.version}`;
}
